'use strict';

const bookFlightManagerModel = require('../modules/models/book_flight_manager').default;
const PRE_SHOPPING_CART = 'preShoppingCart';
const CART_STATUS = require('../../js/modules/utils/cart_status');
Odigeo.defineWidget('book_flight_manager', Odigeo.Widget.extend({
    modelClass: bookFlightManagerModel,

    preBookFlightHandler(data) {
        const info = data.data;
        if (Odigeo.AB.isSummaryContinueButtonLoading) {
            Odigeo.trigger(`${this.id}:resetLoadingButton`);
        }
        if (info && data.typeOfCart === PRE_SHOPPING_CART && !this.model.isSameFlight(info)) {
            this.model.typeOfCart = data.typeOfCart;
            this.model.flightDetail = {
                fareItineraryKey: info.fareItineraryKey,
                flightNumbers: info.flightNumbers,
                segmentKeys: info.segmentKeys,
            };
            this.model.getBookedFlight(info);
        } else {
            const cartStatus = this.model.getShoppingCartStatus();
            if (Odigeo.AB.isSummaryContinueButtonLoading && Odigeo.AB.isPreventBrokenFlowDetailsMobile && cartStatus === CART_STATUS.FAILED) {
                Odigeo.trigger(`${this.id}:shoppingCartFailed`);
            } else if (Odigeo.AB.isSummaryContinueButtonLoading && cartStatus === CART_STATUS.CREATED) {
                Odigeo.trigger(`${this.id}:shoppingCartSuccessfullyCreated`);
            } else if (cartStatus === CART_STATUS.NOT_CREATED) {
                this.model.getBookedFlight(info);
            }
            this.model.executeBookRequestPerformeed();
        }
    },

    preBookFlightHandlerMeta() {
        this.model.typeOfCart = PRE_SHOPPING_CART;
        this.model.getBookedFlight();
    },

    bookFlightHandler(data, callbackFnc = () => {}) {
        if (this.model.typeOfCart) {
            this.model.typeOfCart = null;
            this.model.flightDetail = null;
        }
        this.model.getBookedFlight(data, callbackFnc);
        return true;
    },

    continueWithFlight() {
        this.model.set('continueWithFlight', true);
    },

    continueFromSummary() {
        this.model.set('continueFromSummary', true);
    },

    redirectWhenShoppingCartIsCreated() {
        return this.model.shoppingAlreadyCreated();
    },

    cancelBookFlightHandler() {
        this.model.cancelBookedFlight();
    },

    isShopingCartExecuted() {
        return (!Odigeo._.isNull(this.model.lastShoppingCart));
    },

    selectionAccommodationProductErrorMessage() {
        return this.model.selectionAccommodationProductErrorMessage;
    },

    getSpecifiedAccommodationKeyDifferentFromPreviouslySelectedCode() {
        return this.model.specifiedAccommodationKeyDifferentFromPreviouslySelectedCode;
    },

    getShoppingCartStatus() {
        return this.model.getShoppingCartStatus();
    },

    createShoppingCartRecoveredSession(recoverSessionData) {
        this.bookFlightHandler(recoverSessionData.shoppingCartRequest, recoverSessionData.callbackFnc);
    },

    execute(func, params) {
        if (Odigeo._.isFunction(this[func])) {
            return this[func](params);
        }
    },

    isPreCreateShoppingCart() {
        return this.model.typeOfCart === PRE_SHOPPING_CART;
    },

    isShoppingCartStatusFailed() {
        return this.model.isShoppingCartStatusFailed();
    },

    handleBrokenFlowError() {
        this.model.handleBrokenFlowError();
    },
}));
